module.exports = __webpack_public_path__ + "static/media/steps_d.d9da084e.png";